var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLaptop = function SvgLaptop(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M38 38V39C37.9982 40.6561 36.6561 41.9982 35 42H45C46.6561 41.9982 47.9982 40.6561 48 39V38H38Z",
    fill: "#FC628F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 36V9C47.9982 7.34388 46.6561 6.00176 45 6H5C3.34388 6.00176 2.00176 7.34388 2 9V36H0V39C0.00319616 41.7601 2.2399 43.9968 5 44H45C47.7601 43.9968 49.9968 41.7601 50 39V36H48ZM4 9C4 8.44772 4.44772 8 5 8H45C45.5523 8 46 8.44772 46 9V36H4V9ZM45 42C46.6561 41.9982 47.9982 40.6561 48 39V38H30V40H20V38H2V39C2.00176 40.6561 3.34388 41.9982 5 42H45Z",
    fill: "#FC628F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 8,
    y: 12,
    width: 34,
    height: 20,
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLaptop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/laptop.d6635531ae9de0f28816f4a00ea6cc74.svg";